var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{staticClass:"page__saas"},[_c('PageRow',[_c('VCol',{attrs:{"cols":"12"}},[(_vm.membershipIsVisible)?_c('SaasMembership'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }